import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/en/services/pharmacovigilance/eudravigilance-services")({
  head: () => buildRouteHead("/en/services/pharmacovigilance/eudravigilance-services"),
  component: PVOffering,
});

